const checkAuthorized = (allowed, userType) => allowed === userType;
export default checkAuthorized;
